import { Box, Flex, Group, Menu } from "@mantine/core";
import { FC, useEffect, useState } from "react";
import { ReactComponent as FunnelIcon } from 'assets/funnel.svg';
import { ReactComponent as MapIcon } from "assets/map.svg";
import { ReactComponent as ListBurgerIcon } from "assets/ListBurger.svg";
import { ReactComponent as LeadIcon } from "assets/UserPlus.svg";

export type ViewType = "map" | "list";

interface Props {
  onFunnelClicked: () => void;
  isFunnelActive?: boolean;
  isFilterActive?: boolean;
  onViewChange: (v: ViewType) => void;
  onSearchModeClicked: () => void;
  isSearchModeActive?: boolean;
}

const Header: FC<Props> = ({
  onFunnelClicked,
  isFunnelActive,
  isFilterActive,
  onViewChange,
  onSearchModeClicked,
  isSearchModeActive
}) => {
  const [currentView, setCurrentView] = useState<ViewType>("map");

  useEffect(() => {
    onViewChange(currentView);
  }, [currentView, onViewChange]);

  return (
    <Box 
      style={{
        position: "absolute",
        top: "0",
        left: "",
        zIndex: 999,
        width: "100%",
        height: "36px",
        lineHeight: "36px",
      }}
      bg="#4F7D9C"
      c="white">
      <Flex w="100%" h="100%" justify="space-between" align="center">
        <Box c={isFunnelActive ? "#FF9D00" : "white"} ml="10px">
          <FunnelIcon
            width={24}
            height={24}
            onClick={() => onFunnelClicked()} />
        </Box>
        <Box fz="sm" fw="bold" c="white">
          <Menu closeOnItemClick>
            <Menu.Target>
              <Group gap="5px" m="0">
                {currentView === "map" ? (
                  <>
                    <MapIcon width={24} height={24} />
                    <Box>MAP VIEW</Box>
                  </>
                ) : (
                  <>
                    <ListBurgerIcon width={24} height={24} />
                    <Box>LIST VIEW</Box>
                  </>
                )}
              </Group>
            </Menu.Target>
            <Menu.Dropdown mt="-9px" ml="1px" bg="#4F7D9C" bd="none" c="white"
              style={{
                zIndex: 5002,
              }}>
              <Menu.Item c="white" fw="bold" bg="transparent"
                onClick={() => setCurrentView((prev) => {
                  if (prev === "map") return "list";
                  else return "map";
                })}>
                <Group gap="5px" m="0">
                  {currentView !== "map" ? (
                    <>
                      <MapIcon width={24} height={24} />
                      <Box>MAP VIEW</Box>
                    </>
                  ) : (
                    <>
                      <ListBurgerIcon width={24} height={24} />
                      <Box>LIST VIEW</Box>
                    </>
                  )}
                </Group>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Box>
        <Box c={isSearchModeActive ? "#FF9D00" : "white"} mr="8px"
          onClick={() => onSearchModeClicked()}>
          <LeadIcon width={24} height={24} />
        </Box>
      </Flex>
      {isFilterActive && (
        <Box bg="#FF9D00" h={10} lh="10px" c="white" fz={8} ta="center" fw="bold">
          FILTER IS ON
        </Box>
      )}
      {isSearchModeActive && (
        <Box bg="#0073C1" h={10} lh="10px" c="white" fz={8} ta="center" fw="bold">
          DISPLAYING LEADS FROM SEARCH
        </Box>
      )}
    </Box>
  );
};

export default Header;